import { useLayoutEffect, useRef } from 'react';

import { getFirstIncompleteStepIndex } from '@atlas/react-forms';

export const collectPrefilledValues = form => {
  const values = {};

  (form?.steps ?? []).forEach(step => {
    (step?.fields ?? []).forEach(field => {
      values[field.name] = field.value;
    });
  });

  return values;
};

const useAutoAdvancePrefilledSteps = ({ activeType, isOAuthRegistration, setActiveStep }) => {
  const hasSeededRef = useRef(false);

  useLayoutEffect(() => {
    const shouldntCheckSteps =
      !isOAuthRegistration || hasSeededRef.current || !activeType?.steps?.length;

    if (shouldntCheckSteps) {
      return;
    }

    hasSeededRef.current = true;

    const values = collectPrefilledValues(activeType);
    const targetStep = getFirstIncompleteStepIndex(activeType, values, {
      requireAllFieldsFilled: true,
    });

    if (targetStep > 0) {
      setActiveStep(targetStep);
    }
  }, [activeType, isOAuthRegistration, setActiveStep]);
};

export default useAutoAdvancePrefilledSteps;
